import { Modal } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import { saveResendLinkDetails } from "../../../redux/ResendLinkRegistration/action";
import { Form, Button, message, notification } from "antd";
import "./PartnerMenu.css";
import useSession from "../../CustomLogout/useSession";

const ResendRegistrationLink = ({ drawerOpen, setDrawerOpen, ...props }) => {
  const handleSessionExpired = useSession();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
    setDrawerOpen(true);
  };
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalVisible(false);
    setDrawerOpen(false);
  };

  const signatoryEmail = props.row?.original?.signatoryEmail;
  const signatoryMobile = props.row?.original?.signatoryMobile;

  const handleDeactivatePartner = () => {
    props
      .saveResendLinkDetails({
        access_token: props.access_token,
        partnerFirmId: props.row?.original?.partnerFirmId,
      })
      .then((res) => {
        // setSaveLoading(false);
        if (res && res.status === 200) {
          message.success("Registration link resend successfully ");
          setIsModalVisible(false);
          setDrawerOpen(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  return (
    <div>
      {/* <p
        style={{ cursor: "pointer", color: "#00b1b1" }}
        onClick={() => {
          showModal();
          props.hide && props.hide();
        }}
      >
        Resend Registration Link
      </p> */}

      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        <Form
          autoComplete="off"
          name="resendRegistration"
          layout="vertical"
          form={form}
          onFinish={handleDeactivatePartner}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Resend Registration Link" />
              </Col>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col lg={12} xs={12} md={12} sm={12}>
              <p>
                The Registrayytion link will be resent to the Partner Signatory
                user on the following:{" "}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <p className="color-blue">
                {">"} {signatoryEmail}
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <p className="color-blue">
                {">"} {signatoryMobile}
              </p>
            </Col>
          </Row>
          <Row className="">
            <Col md={12} className="d-flex justify-content-end">
              {/* {saveLoading && (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              )} */}
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>{" "}
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveResendLinkDetails: (data) => dispatch(saveResendLinkDetails(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResendRegistrationLink);
